import { useEffect } from "react";
import { Box, Heading, Flex, Text, Icon, Spinner } from "@chakra-ui/react";
import {
  primary,
  primaryAlt,
  textSecondary,
  white,
} from "../../../../utils/colors.js";
import { useTranslation } from "react-i18next";
import useThemeColors from "../../../../hooks/useThemeColors.js";
import { FaBoltLightning, FaDollarSign, FaUser } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { getPatientStatisticsNewAction } from "../../../../actions/statisticActions.js";
import { useParams } from "react-router-dom";
import useCurrencySymbol from "../../../../hooks/useCurrencySymbol";

const DashboardMoreStats = ({ currency }) => {
  const { slug } = useParams();
  const { t } = useTranslation();
  const { textPrimaryMode } = useThemeColors();

  // STATE
  const currencySymbol = useCurrencySymbol(currency);

  // REDUX
  const dispatch = useDispatch();

  const statisticPatientNew = useSelector((state) => state.statisticPatientNew);

  const { statisticPatientsNew } = statisticPatientNew;

  // USE EFFECT
  useEffect(() => {
    dispatch(getPatientStatisticsNewAction(slug));
  }, [dispatch, slug]);

  // LOG
  // console.log("statisticPatientsNew", statisticPatientsNew);

  return (
    <Box
      bg={white}
      w="100%"
      borderRadius="1rem"
      p="1rem 1.5rem"
      //   h="172px"
      //   minH="172px"
      //   maxH="172px"
      h={["160px", "146px"]}
      minH={["160px", "146px"]}
      maxH={["160px", "146px"]}
    >
      <Flex w="100%" align="center" justify="space-between" minH="2rem">
        <Heading
          fontSize="1.125rem"
          fontWeight="600"
          color={textPrimaryMode}
          mr="0.5rem"
        >
          {t("dashboard.patientStats")}
        </Heading>
      </Flex>

      <Flex w="100%" align="center" justify="center" m="0.5rem 0 0" gap="2rem">
        <Flex
          align="center"
          justify="center"
          direction="column"
          textAlign="center"
        >
          <Flex
            bg={textPrimaryMode}
            align="center"
            justify="center"
            w="1.25rem"
            h="1.25rem"
            borderRadius="0.5rem"
          >
            <Icon as={FaUser} fontSize="0.65rem" color={white} />
          </Flex>
          <Flex
            align="center"
            justify="center"
            direction="column"
            m="0.5rem 0 0"
          >
            {statisticPatientsNew ? (
              <Text
                m="0.25rem 0 0"
                fontSize="1.25rem"
                color={textPrimaryMode}
                fontWeight="500"
                lineHeight="1"
              >
                {statisticPatientsNew?.totalPatients}
              </Text>
            ) : (
              <Box h="20px" m="0.25rem 0 0">
                <Spinner size="sm" color={primary} />
              </Box>
            )}
            <Text fontSize="xs" color={textSecondary} fontWeight="500">
              {t("dashboard.totalPatients")}
            </Text>
          </Flex>
        </Flex>

        <Flex
          align="center"
          justify="center"
          direction="column"
          textAlign="center"
        >
          <Flex
            bg={primary}
            align="center"
            justify="center"
            w="1.25rem"
            h="1.25rem"
            borderRadius="0.5rem"
          >
            <Icon as={FaDollarSign} fontSize="0.65rem" color={white} />
          </Flex>
          <Flex
            align="center"
            justify="center"
            direction="column"
            m="0.5rem 0 0"
          >
            {statisticPatientsNew ? (
              <Text
                m="0.25rem 0 0"
                fontSize="1.25rem"
                color={textPrimaryMode}
                fontWeight="500"
                lineHeight="1"
              >
                {currencySymbol}{" "}
                {statisticPatientsNew?.averageTreatmentPlanPrice}
              </Text>
            ) : (
              <Box h="20px" m="0.25rem 0 0">
                <Spinner size="sm" color={primary} />
              </Box>
            )}
            <Text fontSize="xs" color={textSecondary} fontWeight="500">
              {t("dashboard.averageTreatmentPlanPrice")}
            </Text>
          </Flex>
        </Flex>

        <Flex
          align="center"
          justify="center"
          direction="column"
          textAlign="center"
        >
          <Flex
            bg={primaryAlt}
            align="center"
            justify="center"
            w="1.25rem"
            h="1.25rem"
            borderRadius="0.5rem"
          >
            <Icon as={FaBoltLightning} fontSize="0.65rem" color={white} />
          </Flex>
          <Flex
            align="center"
            justify="center"
            direction="column"
            m="0.5rem 0 0"
          >
            {statisticPatientsNew ? (
              <Text
                m="0.25rem 0 0"
                fontSize="1.25rem"
                color={textPrimaryMode}
                fontWeight="500"
                lineHeight="1"
              >
                {statisticPatientsNew?.patientsThisWeek}
              </Text>
            ) : (
              <Box h="20px" m="0.25rem 0 0">
                <Spinner size="sm" color={primary} />
              </Box>
            )}
            <Text fontSize="xs" color={textSecondary} fontWeight="500">
              {t("dashboard.patientsThisWeek")}
            </Text>
          </Flex>
        </Flex>

        {/* <Flex align="center">
          <Flex
            bg={backgroundLight}
            align="center"
            justify="center"
            w="2.5rem"
            h="2.5rem"
            borderRadius="10rem"
            mr="0.5rem"
          >
            <Icon as={TbUsers} fontSize="0.875rem" color={textPrimaryMode} />
          </Flex>
          <Box>
            <Text fontSize="xs" color={textSecondary} fontWeight="500">
              Total patients
            </Text>
            <Text fontSize="1.25rem" color={textPrimaryMode} fontWeight="500">
              100
            </Text>
          </Box>
        </Flex> */}

        {/* <Box>
          <Flex align="center" justify="center">
            <Text fontSize="xs" color={textSecondary} fontWeight="500">
              Average treatment price
            </Text>
          </Flex>
          <Flex align="center">
            <Flex
              bg={backgroundLight}
              align="center"
              justify="center"
              w="2rem"
              h="2rem"
              borderRadius="10rem"
              mr="0.5rem"
            >
              <Icon
                as={TbCurrencyDollar}
                fontSize="0.875rem"
                color={textPrimaryMode}
              />
            </Flex>
            <Text fontSize="1.5rem" color={textPrimaryMode} fontWeight="500">
              3000 €
            </Text>
          </Flex>
        </Box> */}

        {/* <Box>
          <Flex align="center" justify="center">
            <Text fontSize="xs" color={textSecondary} fontWeight="500">
              New patients
            </Text>
          </Flex>
          <Flex align="center">
            <Flex
              bg={backgroundLight}
              align="center"
              justify="center"
              w="2rem"
              h="2rem"
              borderRadius="10rem"
              mr="0.5rem"
            >
              <Icon
                as={TbCurrencyDollar}
                fontSize="0.875rem"
                color={textPrimaryMode}
              />
            </Flex>
            <Text fontSize="1.5rem" color={textPrimaryMode} fontWeight="500">
              2
            </Text>
          </Flex>
        </Box> */}

        {/* <Box>
          <Text fontSize="2rem" color={textPrimaryMode} fontWeight="600">
            3000 €
          </Text>
          <Text fontSize="0.8rem" color={textSecondary} fontWeight="500">
            Average revenue per patient
          </Text>
        </Box> */}
      </Flex>
    </Box>
  );
};

export default DashboardMoreStats;
